import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PageLayout from '../layout/PageLayout';
import DataTable from '../ui/DataTable';
import StatusChip from '../ui/StatusChip';
import ActionIconButton from '../ui/ActionIconButton';
import { notify } from '../feedback/notify';
import { FormatDate } from '../../utils/FormatDate';

export const statusImportacao = (status) => {
    const s = String(status || '').toUpperCase();
    if (s === 'FINALIZADO') return { label: 'Finalizado', tone: 'success' };
    if (s === 'COM_ERROS') return { label: 'Com erros', tone: 'warning' };
    if (s === 'PROCESSANDO') return { label: 'Processando', tone: 'info' };
    return { label: status || '—', tone: 'error' };
};

/** Histórico de importações (obrigações / demonstrações contábeis). */
export default function ImportacoesListPage({ title, subtitle, listEndpoint, importarPath, detalhesPath }) {
    const navigate = useNavigate();

    const [importacoes, setImportacoes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setLoading(false);
            return;
        }
        axios.get(`${process.env.REACT_APP_API_URL}/${listEndpoint}`, {
            headers: {
                Authorization: token
            }
        })
            .then(response => {
                setImportacoes(response.data.importacoes || []);
            })
            .catch(error => {
                console.error('Erro ao buscar importações:', error);
                notify.error('Não foi possível carregar o histórico de importações.');
            })
            .finally(() => setLoading(false));
    }, [listEndpoint]);

    const columns = [
        { key: 'idImportacao', label: 'ID', width: 72 },
        { key: 'criadoEm', label: 'Data', render: (i) => (i?.criadoEm ? FormatDate(i.criadoEm) : '—') },
        { key: 'responsavel', label: 'Responsável', sx: { fontWeight: 500 }, render: (i) => i?.usuario?.Nome || '—' },
        { key: 'totalArquivos', label: 'Arquivos', align: 'right', render: (i) => i?.totalArquivos ?? 0 },
        { key: 'processados', label: 'Processados', align: 'right', render: (i) => i?.processados ?? 0 },
        {
            key: 'erros',
            label: 'Erros',
            align: 'right',
            render: (i) => (
                <span style={{ color: Number(i?.erros) > 0 ? '#B42318' : 'inherit', fontWeight: Number(i?.erros) > 0 ? 600 : 400 }}>
                    {i?.erros ?? 0}
                </span>
            ),
        },
        {
            key: 'status',
            label: 'Status',
            render: (i) => {
                const s = statusImportacao(i?.status);
                return <StatusChip label={s.label} tone={s.tone} />;
            },
        },
        {
            key: 'acoes',
            label: '',
            align: 'right',
            width: 64,
            render: (i) => (
                <ActionIconButton
                    title="Ver detalhes"
                    icon={<ChevronRightIcon fontSize="small" />}
                    onClick={() => navigate(`${detalhesPath}/${i?.idImportacao}`)}
                />
            ),
        },
    ];

    return (
        <PageLayout
            title={title}
            subtitle={subtitle}
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: title }]}
            actions={
                <Button variant="contained" startIcon={<UploadFileOutlinedIcon />} onClick={() => navigate(importarPath)}>
                    Nova importação
                </Button>
            }
        >
            <DataTable
                columns={columns}
                rows={importacoes}
                getRowKey={(i, idx) => i?.idImportacao ?? idx}
                loading={loading}
                emptyMessage="Nenhuma importação realizada até o momento."
            />
        </PageLayout>
    );
}
